import React from "react";
import { Segment } from "semantic-ui-react";
import PropTypes from "prop-types";

import * as styles from "./highlight-section.module.css";

const HighLightSection = ({ title, subTitle, color="blue" }) => (
  <Segment
    basic
    textAlign="center"
    vertical
    inverted
    className={styles.section + " " + color}
    style={{marginBottom: "20px"}}
  >
    <h1 className={styles.section_h1}>{title}</h1>
    { subTitle && <h2 className={styles.section_h2}>{subTitle}</h2> }
  </Segment>
);

HighLightSection.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  subTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
};

export default HighLightSection;
